import React from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import Home from "./components/Home";
import BulkReporting from "./components/BulkReporting";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Table from "./components/Table";
import Dashboard from "./components/Dashboard";
// import "preline/preline"

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col text-white bg-gray-100 min-h-screen">
      <Header /> {/* Fixed Header */}
      <main className="flex-grow">{children}</main> {/* Main content */}
      <Footer /> {/* Fixed Footer */}
    </div>
  );
};
function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Routes without Header and Footer */}
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Routes with Header and Footer */}
          <Route
            path="/home"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route
            path="/bulk-reporting"
            element={
              <Layout>
                <BulkReporting />
              </Layout>
            }
          />
          <Route
            path="/table"
            element={
              <Layout>
                <Table />
              </Layout>
            }
          />
          <Route
            path="/dashboard"
            element={
              <Layout>
                <Dashboard />
              </Layout>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
